import { getCookie } from '../utils/cookie';

import request, { apiURL } from '../utils/api';
class EmploymentStatusService {
  getAll() {
    const options = {
      headers: {
        Authorization: getCookie('session_id'),
        'Content-Type': 'application/json',
      },
    };
    return request(`${apiURL}/employmentStatuses`, options);
  }
}

export default EmploymentStatusService;
